import React, { useState } from 'react';
import { Text, Input, InputGroup, InputLeftElement, Menu, MenuButton, MenuList, MenuItem, Button, HStack, Portal } from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';

// Country data with flags and codes
const countries = [
  { code: '+1', flag: '🇺🇸', name: 'United States' },
  { code: '+44', flag: '🇬🇧', name: 'United Kingdom' },
  { code: '+49', flag: '🇩🇪', name: 'Germany' },
  { code: '+33', flag: '🇫🇷', name: 'France' },
  { code: '+39', flag: '🇮🇹', name: 'Italy' },
  { code: '+34', flag: '🇪🇸', name: 'Spain' },
  { code: '+31', flag: '🇳🇱', name: 'Netherlands' },
  { code: '+371', flag: '🇱🇻', name: 'Latvia' },
  { code: '+372', flag: '🇪🇪', name: 'Estonia' },
  { code: '+370', flag: '🇱🇹', name: 'Lithuania' },
  { code: '+7', flag: '🇷🇺', name: 'Russia' },
  { code: '+86', flag: '🇨🇳', name: 'China' },
  { code: '+81', flag: '🇯🇵', name: 'Japan' },
  { code: '+82', flag: '🇰🇷', name: 'South Korea' },
  { code: '+91', flag: '🇮🇳', name: 'India' },
];

interface PhoneInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const PhoneInput: React.FC<PhoneInputProps> = ({ value, onChange, placeholder = "12 345 678" }) => {
  const [selectedCountry, setSelectedCountry] = useState(countries.find(country => country.code === '+371') || countries[0]);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <InputGroup>
      <Input
        placeholder={placeholder}
        value={value}
        onChange={(e) => {
          // Only allow digits and spaces
          const filteredValue = e.target.value.replace(/[^\d\s]/g, '');
          onChange(filteredValue);
        }}
        backgroundColor="#120F1B"
        color="#FFFFFF"
        borderRadius="48px"
        height="44px"
        paddingLeft="107px"
        paddingRight="20px"
        fontFamily="Urbanist, sans-serif"
        fontWeight="500"
        fontSize="16px"
        border="none"
        _placeholder={{
          color: "#90909A",
          opacity: 1
        }}
        _focus={{
          boxShadow: "none",
          border: "none"
        }}
      />
      <InputLeftElement
        position="absolute"
        left="10px"
        top="50%"
        transform="translateY(-50%)"
        width="68px"
        height="16px"
        display="flex"
        alignItems="center"
        justifyContent="flex-start"
      >
        <Menu
          isLazy
          placement="top-start"
          closeOnBlur={false}
          strategy="fixed"
          gutter={8}
          isOpen={isMenuOpen}
          onOpen={() => setIsMenuOpen(true)}
          onClose={() => setIsMenuOpen(false)}
        >
          <MenuButton
            as={Button}
            backgroundColor="transparent"
            color="#FFFFFF"
            fontFamily="Urbanist, sans-serif"
            fontWeight="500"
            fontSize="16px"
            lineHeight="1em"
            padding="0"
            height="16px"
            _hover={{ backgroundColor: "transparent" }}
            _active={{ backgroundColor: "transparent" }}
            _focus={{ backgroundColor: "transparent" }}
          >
            <HStack spacing="4px">
              <Text fontSize="16px" lineHeight="1">{selectedCountry.flag}</Text>
              <Text fontSize="16px" color="#FFFFFF" lineHeight="1em" fontFamily="Urbanist, sans-serif">{selectedCountry.code}</Text>
              <ChevronDownIcon color="#FFFFFF" boxSize="10px" ml="8px" />
            </HStack>
          </MenuButton>
          <Portal>
            <MenuList
              backgroundColor="#1D1D1D"
              border="1px solid #90909A"
              borderRadius="8px"
              maxHeight="180px"
              overflowY="auto"
              zIndex={9999}
              className="country-dropdown-menu"
              data-testid="country-dropdown"
            >
            {countries.map((country, index) => (
              <MenuItem
                key={index}
                backgroundColor="transparent"
                color="#FFFFFF"
                fontFamily="Urbanist, sans-serif"
                fontWeight="500"
                fontSize="14px"
                _hover={{ backgroundColor: "#2A2A2A" }}
                _focus={{ backgroundColor: "#2A2A2A" }}
                onClick={() => setSelectedCountry(country)}
              >
                <HStack spacing="8px">
                  <Text fontSize="14px">{country.flag}</Text>
                  <Text fontSize="14px">{country.code}</Text>
                  <Text fontSize="12px" color="#90909A">{country.name}</Text>
                </HStack>
              </MenuItem>
            ))}
            </MenuList>
          </Portal>
        </Menu>
      </InputLeftElement>
    </InputGroup>
  );
};

export default PhoneInput;

